import React, { useState } from "react"
import { graphql } from "gatsby"
import { animated, useSpring } from "react-spring"
import { Waypoint } from "react-waypoint"
import BackgroundImage from "gatsby-background-image"
import { Row, Col } from "react-flexbox-grid"
import Img from "gatsby-image"
import FsLightbox from "fslightbox-react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import FooterMenu from "../components/footer-menu/footer-menu"
import Play from "../components/play/play"

import "./index.sass"

const LANDING =
  "https://player.vimeo.com/external/345747277.hd.mp4?s=23b924a2d869835c26df68632cf05e0a48fddd9c&profile_id=175"

const IndexPage = props => {
  const [toggler, setToggler] = useState(false)
  const [on, toggle] = useState(false)
  const [side, setEnter] = useState(false)
  const [summerOn, setSummerHandler] = useState(false)
  const [winterOn, setWinterHandler] = useState(false)
  const [gardenOn, setGardenHandler] = useState(false)
  const [carOn, setCarHandler] = useState(false)
  const [carContentOn, setCarContentHandler] = useState(false)
  const [floodOn, setFloodHandler] = useState(false)
  const [floodContentOn, setFloodContentHandler] = useState(false)

  const fade = useSpring({
    opacity: on ? 1 : 0,
    transform: on ? "translate3d(0, 0, 0)" : "translate3d(0, 30px, 0)",
  })

  const fadeFirst = useSpring({
    opacity: side ? 1 : 0,
    transform: side ? "translate3d(0, 0, 0)" : "translate3d(0, 30px, 0)",
  })

  const fadeSummer = useSpring({
    opacity: summerOn ? 1 : 0,
    transform: summerOn ? "translate3d(0, 0, 0)" : "translate3d(-30px, 0, 0)",
  })

  const fadeWinter = useSpring({
    opacity: winterOn ? 1 : 0,
    transform: winterOn ? "translate3d(0, 0, 0)" : "translate3d(30px, 0, 0)",
  })

  const fadeGarden = useSpring({
    opacity: gardenOn ? 1 : 0,
    transform: gardenOn ? "translate3d(0, 0, 0)" : "translate3d(0, 30px, 0)",
  })

  const fadeCar = useSpring({
    opacity: carOn ? 1 : 0,
    transform: carOn ? "translate3d(0, 0, 0)" : "translate3d(-30px, 0, 0)",
  })

  const fadeCarContent = useSpring({
    opacity: carContentOn ? 1 : 0,
    transform: carContentOn
      ? "translate3d(0, 0, 0)"
      : "translate3d(30px, 0, 0)",
  })

  const fadeFlood = useSpring({
    opacity: floodOn ? 1 : 0,
    transform: floodOn ? "translate3d(0, 0, 0)" : "translate3d(30px, 0, 0)",
  })

  const fadeFloodContent = useSpring({
    opacity: floodContentOn ? 1 : 0,
    transform: floodContentOn
      ? "translate3d(0, 0, 0)"
      : "translate3d(-30px, 0, 0)",
  })

  const fadeEnter = useSpring({
    from: {
      opacity: 0,
      transform: "translate3d(0, 30px, 0)",
    },
    to: {
      opacity: 1,
      transform: "translate3d(0, 0, 0)",
    },
    delay: 300,
  })
  const fadeSecond = useSpring({
    from: {
      opacity: 0,
      transform: "translate3d(0, 30px, 0)",
    },
    to: {
      opacity: 1,
      transform: "translate3d(0, 0, 0)",
    },
    delay: 500,
  })
  const fadeThird = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
    delay: 700,
  })
  const fadeForth = useSpring({
    from: {
      opacity: 0,
      transform: "translate3d(0, 30px, 0)",
    },
    to: {
      opacity: 1,
      transform: "translate3d(0, 0, 0)",
    },
    delay: 1100,
  })

  return (
    <Layout>
      <SEO title="Home" />
      <div id="home">
        <section id="hero">
          <div className="title-container">
            <animated.h5 style={fadeEnter} className="lead">
              welcome to calgary
            </animated.h5>
            <animated.h1 style={fadeSecond} className="hero-title">
              the concord
            </animated.h1>
          </div>
          <Row className="start-lg">
            <div className="grid-line line-1"></div>
            <div className="grid-line line-2"></div>
            <Col lg={3}></Col>
            <Col md={12} lg={9}>
              <animated.div style={fadeThird} className="vid-container">
                <div
                  onClick={() => setToggler(!toggler)}
                  role="button"
                  onKeyDown={() => setToggler(!toggler)}
                  tabIndex={0}
                >
                  <video
                    src={LANDING}
                    data-keepplaying
                    autoPlay
                    muted
                    loop
                    playsInline
                  />
                  <div className="vid-overlay" />
                  <Play />
                </div>
                <FsLightbox
                  toggler={toggler}
                  sources={[
                    "https://www.youtube.com/watch?time_continue=1&v=wGmsiFBnyq4",
                  ]}
                />
              </animated.div>
            </Col>
          </Row>
          <Row className="center-xs end-lg">
            <Col xs={0} md={1} lg={3}></Col>
            <Col xs={12} md={10} lg={7}>
              <animated.div style={fadeForth} className="content-wrapper">
                <h1 className="title">The One and Only Location</h1>
                <p className="desc">
                  A spectacular riverfront property at Eau Claire situated on a
                  promontory, the one and only residential development with
                  unparalleled location and destined to become a focal point for
                  downtown Calgary.
                </p>
              </animated.div>
            </Col>
            <Col xs={0} md={1} lg={2}></Col>
          </Row>
        </section>
        <section id="masterpiece">
          <div className="bg-img">
            <Img fluid={props.data.grid.childImageSharp.fluid} />
          </div>
          <Row className="center-xs start-lg">
            <Col xs={1} md={1} lg={2} />
            <Col xs={10} md={10} lg={10}>
              <Waypoint
                bottomOffset="30%"
                onEnter={() => {
                  if (!on) toggle(true)
                }}
              >
                <animated.h1 style={fade} className="title">
                  Creation of a Masterpiece
                </animated.h1>
              </Waypoint>
            </Col>
            <Col xs={1} md={1} />
          </Row>
          <Row className="center-xs between-md start-lg">
            <Col xs={0} md={1} lg={2} />
            <Col xs={10} md={4} lg={3}>
              <Waypoint
                bottomOffset="30%"
                onEnter={() => {
                  if (!on) toggle(true)
                }}
              >
                <animated.div style={fade} className="architect">
                  <Img fluid={props.data.erickson.childImageSharp.fluid} />
                  <p className="caption">arthur erickson</p>
                  <p className="desc">
                    One of Canada’s most celebrated architects, Arthur
                    Erickson’s work formed the initial design inspiration for
                    The Concord.
                  </p>
                </animated.div>
              </Waypoint>
            </Col>
            <Col md={1} lg={1} />
            <Col xs={10} md={5} lg={4}>
              <Waypoint
                bottomOffset="45%"
                onEnter={() => {
                  if (!side) setEnter(true)
                }}
              >
                <animated.div style={fadeFirst} className="architect">
                  <p className="desc">
                    With long-term colleague and business partner, Nick
                    Milkovich, Erickson established the design path for The
                    Concord to artfully complement its extraordinary downtown
                    Calgary location.
                  </p>
                  <Img fluid={props.data.nick.childImageSharp.fluid} />
                  <p className="caption">Nick Milkovich</p>
                </animated.div>
              </Waypoint>
            </Col>
            <Col md={1} lg={3} />
          </Row>
        </section>
        <section id="garden">
          <Row center="xs" start="lg">
            <Col xs={10} lg={5} lgOffset={2}>
              <Waypoint
                bottomOffset="10%"
                onEnter={() => {
                  if (!gardenOn) setGardenHandler(true)
                }}
              >
                <animated.div style={fadeGarden}>
                  <h1 className="title">
                    Outdoor Water Garden to Winter Wonderland
                  </h1>
                  <p className="desc">
                    At the heart of The Concord is a central summer garden with
                    water feature. During winter time, the central water feature
                    becomes a private ice skating rink that reflects the
                    changing of the seasons along the riverside.
                  </p>
                </animated.div>
              </Waypoint>
            </Col>
          </Row>
          <div className="garden-images-container">
            <div className="padding" />
            <Row center="xs" end="lg">
              <Col xs={12} className="garden summer" md lg={6}>
                <Waypoint
                  bottomOffset="40%"
                  onEnter={() => {
                    if (!summerOn) setSummerHandler(true)
                  }}
                >
                  <animated.div style={fadeSummer}>
                    <p className="caption caption-top">summer</p>
                    <Img fluid={props.data.summer.childImageSharp.fluid} />
                  </animated.div>
                </Waypoint>
              </Col>
              <Col xs={12} className="garden winter" md lg={6}>
                <Waypoint
                  bottomOffset="40%"
                  onEnter={() => {
                    if (!winterOn) setWinterHandler(true)
                  }}
                >
                  <animated.div style={fadeWinter}>
                    <p className="caption caption-top">winter</p>
                    <Img fluid={props.data.winter.childImageSharp.fluid} />
                  </animated.div>
                </Waypoint>
              </Col>
            </Row>
          </div>
        </section>
        <section id="parkade">
          <Row center="xs" start="lg" middle="lg" className="parkade-content">
            <Col xs={12} lg={6}>
              <Waypoint
                bottomOffset="30%"
                onEnter={() => {
                  if (!carOn) setCarHandler(true)
                }}
              >
                <animated.div style={fadeCar}>
                  <BackgroundImage
                    Tag="section"
                    className="parkade"
                    fluid={props.data.car.childImageSharp.fluid}
                  />
                </animated.div>
              </Waypoint>
            </Col>
            <Col xs={10} xsOffset={1} lg={4} lgOffset={1}>
              <Waypoint
                bottomOffset="30%"
                onEnter={() => {
                  if (!carContentOn) setCarContentHandler(true)
                }}
              >
                <animated.div
                  style={fadeCarContent}
                  className="col-content-wrapper"
                >
                  <h1 className="title">
                    State-of-the-art Underground Parkade
                  </h1>
                  <p className="desc">
                    The Concord takes the importance of car care and cleaning
                    into considerations. An automated undercarriage and tire
                    wash is located near the entrance of the parkade along with
                    a heated entrance ramp to keep the area slip-free. For those
                    who prefer a speedier approach, a four-cycle touchless warm
                    water car wash is also available at their disposal.
                  </p>
                </animated.div>
              </Waypoint>
            </Col>
          </Row>
        </section>
        <section id="floodgate">
          <Row center="xs" start="lg" middle="lg" className="parkade-content">
            <Col xs={12} lg={6} lgOffset={1}>
              <Waypoint
                bottomOffset="30%"
                onEnter={() => {
                  if (!floodOn) setFloodHandler(true)
                }}
              >
                <animated.div style={fadeFlood}>
                  <BackgroundImage
                    Tag="section"
                    className="parkade"
                    fluid={props.data.flood.childImageSharp.fluid}
                  />
                </animated.div>
              </Waypoint>
            </Col>
            <Col xs={10} xsOffset={1} lg={4}>
              <Waypoint
                bottomOffset="30%"
                onEnter={() => {
                  if (!floodContentOn) setFloodContentHandler(true)
                }}
              >
                <animated.div
                  style={fadeFloodContent}
                  className="col-content-wrapper"
                >
                  <h1 className="title">Engineered Beyond Compare</h1>
                  <p className="desc">
                    The Concord takes multiple measures and a comprehensive
                    approach in designing for flood and emergency preparedness.
                    From self-repairing foundation walls, to flood fortification
                    strategy and back-up power systems, giving the peace of mind
                    to every homeowner.
                  </p>
                </animated.div>
              </Waypoint>
            </Col>
          </Row>
        </section>
      </div>
      <FooterMenu />
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    erickson: file(relativePath: { eq: "arthur_erickson.png" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    nick: file(relativePath: { eq: "nick.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    grid: file(relativePath: { eq: "grid.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    winter: file(relativePath: { eq: "winter.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    summer: file(relativePath: { eq: "summer.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    car: file(relativePath: { eq: "car.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    flood: file(relativePath: { eq: "floodgate.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
